var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "top" } },
    [
      _c("headNav", { attrs: { gray: _vm.gray } }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("foot-nav")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "innerWrapper" }, [
      _c("h1", [_vm._v("About us")]),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n      Integrity! Transparency! Quality! This is what UNIFI represents. UNIFI\n      is a Business to Business platform that is revolutionising the way that\n      off-the-plan and new property is being purchased."
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "\n      UNIFI is a property platform that will assist all investors and home\n      buyers and give them access to pre-qualified, researched and quality\n      properties. Whether it is an off-the-plan townhouse, apartment, sky\n      terrace or house and land package, we ensure that a rigorous selection\n      process is undertaken prior to approving a property to be released on\n      the UNIFI platform. Quality is something that will not be compromised.\n      With easy-to-access due diligence available for all properties, finding\n      the right one for your client will be easy."
        ),
        _c("br"),
        _c("br"),
        _vm._v(
          "\n      UNIFI is unifying all industries and offering a seamless purchasing\n      method for introducers and buyers alike. Mortgage and Finance Brokers,\n      Accountants, Real Estate Agents, Financial Planners and qualified\n      advisors gain access to all properties on the platform being able to\n      match the right property to their client's needs. With accessibility in\n      mind, our referrers can filter through and find the perfect property for\n      their client within minutes. Assisting clients in purchasing the perfect\n      property has never been easier.\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bigImg" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c0d6562", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c0d6562","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/more/abous.vue
// module id = null
// module chunks = 